import { Link } from "react-router-dom";
import { ArrowRight, TestTube, ClipboardCheck } from "lucide-react";
import { useGrandeTesteSummary } from '@/hooks/useGrandeTesteSummary';

const TestesSection = () => {
  const { totalPerguntas, totalCapitulos } = useGrandeTesteSummary();
  return (
  <section id="testes" className="py-16 sm:py-24 bg-card/30">
    <div className="container mx-auto px-5 sm:px-4">
      <div className="text-center mb-10 sm:mb-16">
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
          <span className="text-gradient-green">Testes </span>de Estilo
        </h2>
        <p className="text-base sm:text-xl text-muted-foreground max-w-2xl mx-auto">
          Escolha o teste ideal para descobrir suas Personas de Estilo.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 sm:gap-8 max-w-4xl mx-auto mb-10 sm:mb-12">
        {/* Teste Express */}
        <div className="rounded-3xl p-6 sm:p-8 bg-card border border-border/50">
          <div className="w-14 h-14 rounded-2xl bg-primary/10 mb-4 flex items-center justify-center">
            <TestTube className="w-7 h-7 text-primary" />
          </div>
          <h3 className="font-display text-xl sm:text-2xl font-bold mb-3">
            Teste Express de Estilo + <br className="hidden sm:block" />
            Perfil de Estilo
          </h3>
          <p className="text-sm sm:text-base text-muted-foreground mb-6">
            Um teste rápido, para você obter um primeiro direcionamento sobre quais são suas personas mais fortes
            <br className="hidden sm:block" />
            No teste express você recebe seu perfil de estilo em forma de gráfico, com os pesos percentuais de cada uma de suas 12 personas.
          </p>
          <Link
            to="/teste"
            className="w-full py-3 rounded-full font-semibold transition-all hover:scale-105 inline-flex items-center justify-center bg-primary text-primary-foreground"
          >
            Fazer o Teste Express
            <ArrowRight className="w-5 h-5 ml-2" />
          </Link>
        </div>

        {/* Grande Teste */}
        <div className="rounded-3xl p-6 sm:p-8 bg-primary text-primary-foreground border-2 border-primary shadow-glow-strong">
          <div className="w-14 h-14 rounded-2xl bg-primary-foreground/20 mb-4 flex items-center justify-center">
            <ClipboardCheck className="w-7 h-7 text-primary-foreground" />
          </div>
          <h3 className="font-display text-xl sm:text-2xl font-bold mb-3">
            Grande Teste das 12 Personas + <br className="hidden sm:block" /> Mapa de Estilo
          </h3>
          <p className="text-sm sm:text-base text-primary-foreground/80 mb-6">
            Um teste com {totalPerguntas} questões divididas em {totalCapitulos} capítulos que permitirá uma visão mais detalhada de sua essência de Estilo. <br className="hidden sm:block" />
            No Grande teste das 12 Personas você recebe seu Mapa de Estilo personalizado, uma análise profunda de seu estilo. Seu Mapa de Estilo funciona como uma bússula para te guiar em suas escolhas de roupas, acessórios, viagens, livros, músicas e todos os elementos de seu estilo de vida. Tudo feito para que você expresse seu estilo de forma autêntica e interessante.
          </p>
          <a
            href="https://hallal.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full py-3 rounded-full font-semibold transition-all hover:scale-105 inline-flex items-center justify-center bg-background text-foreground hover:bg-foreground hover:text-background"
          >
            Fazer o Grande Teste
            <ArrowRight className="w-5 h-5 ml-2" />
          </a>
        </div>
      </div>

      <div className="text-center">
        <p className="text-sm sm:text-base text-muted-foreground">
          Se você é{" "}
          <span className="font-bold text-lg sm:text-2xl text-foreground">CONSULTOR DE IMAGEM</span> e Estilo aplique nosso Grande Teste das 12 Personas de Estilo em seus clientes com entrega do Mapa de Estilo com condição diferenciada{" "}
          <Link to="/consultores" className="text-primary hover:underline font-semibold">
            Saiba mais sobre condições para Consultores
          </Link>
        </p>
      </div>
    </div>
  </section>
);
};

export default TestesSection;
